import { Grid, GridColumn, Dropdown, Input } from 'semantic-ui-react';
import { US_STATES } from '~/features/dashboards/AdminDashboard/usStates';
import { BID_REVENUE_TYPE_OPTIONS, BID_STATUSES, BID_UNITS } from './constants';
import { BidFiltersType } from '~/types/bid/BidFiltersType';

interface BidFiltersProps {
    filters: BidFiltersType;
    onFiltersChange: (filters: BidFiltersType) => void;
}

const colStyle = { padding: '1rem 0 0 1rem' };
const controlFontSize = { fontSize: '.9rem' };

export default function BidFilters({ filters, onFiltersChange }: BidFiltersProps) {
    const handleFilterChange = <K extends keyof BidFiltersType>(key: K, value: BidFiltersType[K]) => {
        onFiltersChange({
            ...filters,
            [key]: value,
        });
    };

    return (
        <div style={{ margin: '1rem 0 2rem', paddingRight: '1rem' }}>
            <Grid stackable>
                <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
                    <Input
                        type='text'
                        placeholder='Project name...'
                        value={filters.projectName}
                        onChange={e => handleFilterChange('projectName', e.target.value)}
                        fluid
                        style={controlFontSize}
                    />
                </GridColumn>

                <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
                    <Input
                        type='text'
                        placeholder='Portfolio name...'
                        value={filters.portfolioName}
                        onChange={e => handleFilterChange('portfolioName', e.target.value)}
                        fluid
                        style={controlFontSize}
                    />
                </GridColumn>

                <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
                    <Input
                        type='text'
                        placeholder='Investor company...'
                        value={filters.investorCompanyName}
                        onChange={e => handleFilterChange('investorCompanyName', e.target.value)}
                        fluid
                        style={controlFontSize}
                    />
                </GridColumn>

                <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
                    <Dropdown
                        placeholder='Bid unit...'
                        fluid
                        multiple
                        search
                        selection
                        clearable
                        options={BID_UNITS.map(unit => ({
                            key: unit,
                            text: unit,
                            value: unit,
                        }))}
                        value={filters.selectedUnits}
                        onChange={(_e, { value }) => handleFilterChange('selectedUnits', value as string[])}
                        style={controlFontSize}
                        selectOnBlur={false}
                    />
                </GridColumn>

                <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
                    <Dropdown
                        placeholder='Revenue type...'
                        fluid
                        search
                        selection
                        clearable
                        options={BID_REVENUE_TYPE_OPTIONS}
                        value={filters.selectedDeploymentType || ''}
                        onChange={(_e, { value }) =>
                            handleFilterChange('selectedDeploymentType', (value as string | undefined) ?? '')
                        }
                        style={controlFontSize}
                        selectOnBlur={false}
                    />
                </GridColumn>

                <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
                    <Dropdown
                        placeholder='State...'
                        fluid
                        search
                        selection
                        clearable
                        options={US_STATES}
                        value={filters.state || ''}
                        onChange={(_e, { value }) =>
                            handleFilterChange('state', (value as string | undefined) ?? '')
                        }
                        style={controlFontSize}
                        selectOnBlur={false}
                    />
                </GridColumn>

                <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
                    <Dropdown
                        placeholder='Bid status...'
                        fluid
                        multiple
                        search
                        selection
                        clearable
                        options={BID_STATUSES.map(status => ({
                            key: status,
                            text: status,
                            value: status,
                        }))}
                        value={filters.selectedStatuses}
                        onChange={(_e, { value }) => handleFilterChange('selectedStatuses', value as string[])}
                        style={controlFontSize}
                        selectOnBlur={false}
                    />
                </GridColumn>
            </Grid>
        </div>
    );
}